import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "code-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "remember-and-login" }

import { onMounted, reactive, ref } from "vue";
import { AdminService } from "@/api/services/AdminService";
import { AdminLoginRequest } from "@/api/models/admin/AdminLoginRequest";
import router from "@/router";
import axios from "axios";
import { message } from "ant-design-vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const remember = ref(false);
const loading = ref(false);
const captchaImage = ref<string>("");

const loginRequest = reactive<AdminLoginRequest>({
  account: "",
  password: "",
  id: "",
  code: "",
});

const submitLogin = async () => {
  loading.value = true;
  const res = await AdminService.Login(loginRequest);
  if (res.code === 0) {
    if (remember.value) {
      localStorage.setItem("remember", "true");
      localStorage.setItem("account", loginRequest.account);
      localStorage.setItem("password", loginRequest.password);
    } else {
      localStorage.setItem("remember", "false");
    }
    localStorage.setItem("A-Token", res.data);
    loading.value = false;
    message.success("登录成功");
    await router.push({ path: "/", replace: true });
    setTimeout(() => location.reload(), 500);
  } else {
    message.error(res.msg);
    loading.value = false;
    await refreshCaptcha();
  }
};

const handleCode = async () => {
  const res = await AdminService.GetCode();
  loginRequest.id = res.data;
};

const handleImage = async () => {
  const res = await axios.post(
    process.env.VUE_APP_BASE_URL + "/admin/image",
    { id: loginRequest.id },
    { responseType: "blob" }
  );
  const blob = new Blob([res.data], { type: res.headers["content-type"] });
  captchaImage.value = URL.createObjectURL(blob);
};

const refreshCaptcha = async () => {
  await handleCode();
  await handleImage();
};

onMounted(() => {
  if (localStorage.getItem("remember") === "true") {
    loginRequest.account = localStorage.getItem("account") ?? "";
    loginRequest.password = localStorage.getItem("password") ?? "";
    remember.value = true;
  }
  refreshCaptcha();
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: loginRequest,
      autocomplete: "off",
      class: "login-form",
      onSubmit: submitLogin
    }, {
      default: _withCtx(() => [
        _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "form-title" }, "后台管理系统", -1)),
        _createVNode(_component_a_form_item, { label: "账号" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: loginRequest.account,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((loginRequest.account) = $event)),
              placeholder: "请输入账号",
              clearable: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: loginRequest.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((loginRequest.password) = $event)),
              type: "password",
              placeholder: "请输入密码"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          label: "验证码",
          class: "code-item"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_input, {
                value: loginRequest.code,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((loginRequest.code) = $event)),
                placeholder: "请输入验证码",
                clearable: ""
              }, null, 8, ["value"]),
              _createElementVNode("div", {
                class: "code-image",
                onClick: refreshCaptcha
              }, [
                (captchaImage.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: captchaImage.value,
                      alt: "验证码"
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("span", _hoisted_4, "加载中..."))
              ])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_checkbox, {
            checked: remember.value,
            "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((remember).value = $event)),
            class: "remember-me"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("记住我 ")
            ])),
            _: 1
          }, 8, ["checked"]),
          _createVNode(_component_a_button, {
            type: "primary",
            class: "login-btn",
            "html-type": "submit",
            loading: loading.value
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" 登录 ")
            ])),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})